import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  ProgressRing as ProgressRingBase,
  TYPOGRAPHY,
  TYPOGRAPHY_CLASSNAMES,
  SPACINGS,
  cssByBreakpoint,
  BREAKPOINTS,
  useMediaQuery,
} from '@figure/figure-frontlib-gui';
import { Divider } from './Divider';

const H1 = styled.h1`
  ${cssByBreakpoint(
    [
      css`
        ${TYPOGRAPHY.H5}
        }
      `,
      css`
        ${TYPOGRAPHY.H4}
      `,
    ],
    [BREAKPOINTS.SM]
  )}
`;

const ProgressRing = styled(ProgressRingBase)``;

const TitleAndHeaderContainer = styled.div``;

const HeaderContainer = styled.div`
  display: flex;
  margin-bottom: ${SPACINGS.X3L}px;

  ${TitleAndHeaderContainer} {
    flex: 1 1 auto;
  }

  ${ProgressRing} {
    align-self: center;
    margin-left: ${SPACINGS.M}px;
  }
`;

export const Header = ({ pageTitle, headerCopy, progress }) => {
  const mediaQueryMatches = useMediaQuery();
  const isMobileLayout = !mediaQueryMatches.MD;
  return (
    <>
      <HeaderContainer>
        <TitleAndHeaderContainer>
          {pageTitle && !isMobileLayout && (
            <span className={TYPOGRAPHY_CLASSNAMES.M}>{pageTitle}</span>
          )}
          {headerCopy && <H1>{headerCopy}</H1>}
        </TitleAndHeaderContainer>
        {!!progress && !isMobileLayout && (
          <ProgressRing currentStep={progress.currentStep} totalSteps={progress.totalSteps} />
        )}
      </HeaderContainer>
      {!isMobileLayout && <Divider />}
    </>
  );
};
Header.propTypes = {
  pageTitle: PropTypes.string,
  headerCopy: PropTypes.string,
  progress: PropTypes.shape({
    currentStep: PropTypes.number,
    totalSteps: PropTypes.number,
  }),
};
Header.defaultProps = {
  pageTitle: '',
  headerCopy: '',
  progress: null,
};
